import checkout from "./Form";

const {
  formField: {
    // messages
    message,
    // datas
    fullName,
		socialName,
		CPF,
		birthDate,
		sex,
		documentType,
		documentNumber,
		issuingAgency,
		FUData,
		issueDate,
		nationality,
		birthCity,
		birthFU,
		motherName,
		fatherName,
    // contacts
		email,
    phone,
    formOfContact,
    contact,
    // address
    CEP,
    street,
    number,
    complements,
    FUAddress,
    district,
    city,
    mailingAddress,
    // complements
    income,
    // descriptions
    privateDescription,
    accountNumber
    // documents
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // messages
  [message.name]: "",
  // datas
  [fullName.name]: "",
  [socialName.name]: "",
  [CPF.name]: "",
  [birthDate.name]: "",
  [sex.name]: "",
  [documentType.name]: "",
  [documentNumber.name]: "",
  [issuingAgency.name]: "",
  [FUData.name]: "",
  [issueDate.name]: "",
  [nationality.name]: "",
  [birthCity.name]: "",
  [birthFU.name]: "",
  [motherName.name]: "",
  [fatherName.name]: "",
  // contacts
  [email.name]: "",
  [phone.name]: "",
  [formOfContact.name]: "",
  [contact.name]: "",
  // address
  [CEP.name]: "",
  [street.name]: "",
  [number.name]: "",
  [complements.name]: "",
  [FUAddress.name]: "",
  [district.name]: "",
  [city.name]: "",
  [mailingAddress.name]: "",
  // complements
  [income.name]: "",
  // descriptions
  [privateDescription.name]: "",
  [accountNumber.name]: "",
  // documents
};